import React, {Component, Fragment} from 'react';
import {Button} from "reactstrap";
import MaterialIcon from "material-icons-react";
import i18n from "../../../i18next";
import CreateUpsellProductModal from "./CreateUpsellProductModal";
import {connect} from "react-redux";
import {
    loadUpsellSettingsAndProducts,
    reorderUpsellProducts,
    clearUpsellSettings,
    setUpsellMessage,
    loadRestaurantSettings
} from "../../../actions";
import {getPriceWithCurrencySymbol} from "../../../utils/CommonUtils";
import DeleteUpsellProductModal from "./DeleteUpsellProductModal";
import {SortableContainer, SortableElement} from "react-sortable-hoc";
import Section from "./Section";
import {FRONT_END_URL} from "../../../utils/Constants";

const SortableUpsellProduct = SortableElement(({upsellProduct, restaurantCurrency, showDeleteModal, isLargeImageDesign}) => {
    const {upsellProductItem, imageContainer, image, name, description, price, priority, noImageContainer} = styles;
    const imagePath = isLargeImageDesign ? upsellProduct.productDraft.mainRectImagePath : upsellProduct.productDraft.mainImagePath

    return (
        <div style={upsellProductItem}>
                            <span onClick={() => {
                                showDeleteModal(upsellProduct.upsellId)
                            }} className={"upsellCloseButton"}>
                                <MaterialIcon icon="delete_outline"/>
                            </span>
            <div style={imageContainer}>
                {imagePath ?
                    <img style={image}
                         draggable={false}
                         src={`${FRONT_END_URL}/${imagePath}`}/>
                :
                    <div style={noImageContainer}>
                        {i18n.t('screens:upsellScreen.noImage')}
                    </div>
                }

            </div>
            <div style={name}>
                {upsellProduct.productDraft.posSizeName ? `${upsellProduct.productDraft.posSizeName} ` : ''}{upsellProduct.productDraft.posName}
            </div>
            <div style={description}>
                {upsellProduct.productDraft.posDescription}
            </div>
            <div style={price}>
                {getPriceWithCurrencySymbol(upsellProduct.productDraft.posPrice, restaurantCurrency)}
            </div>
            <div style={priority}>
                Priority: <b>{upsellProduct.priority}</b>
            </div>
        </div>
    )
});

const SortableUpsellList = SortableContainer(({upsellProducts, restaurantCurrency, showDeleteModal, isLargeImageDesign}) => {

    const {productContainer} = styles;
    return (
        <div id="upsellProductContainer" style={productContainer}>
            {upsellProducts.map((upsellProduct, index) => {
                return (
                    <SortableUpsellProduct
                        key={upsellProduct.upsellId}
                        index={index}
                        upsellProduct={upsellProduct}
                        restaurantCurrency={restaurantCurrency}
                        showDeleteModal={showDeleteModal}
                        isLargeImageDesign={isLargeImageDesign}
                    />
                )
            })}
        </div>
    )
});

class UpsellScreen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            upsellMessage: '',
            upsellModal: {
                show: false
            },
            removeProductModal: {
                show: false,
                upsellId: -1
            },
            currentProductIds: []
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.upsellSettings.upsellMessage !== prevProps.upsellSettings.upsellMessage) {
            this.setState({...this.state, upsellMessage: this.props.upsellSettings.upsellMessage})
        }

        // if (this.props.upsellSettings.upsellProducts !== prevProps.upsellSettings.upsellProducts) {
        //     this.setState({...this.state, currentProductIds: []}, () => {
        //         let productId= 1;
        //             this.props.upsellSettings.upsellProducts.map((upsellProduct) => {
        //                 this.setState({...this.state, currentProductIds:})
        //             })
        //     })}
        // }
    }

    componentDidMount() {
        const restaurantId = this.props.restaurant.id;
        this.loadUpsellSettingsAndProducts();
        this.props.loadRestaurantSettings(restaurantId);
    }

    componentWillUnmount() {
        this.props.clearUpsellSettings();
    }

    loadUpsellSettingsAndProducts = () => {
        this.props.loadUpsellSettingsAndProducts(this.props.match.params.id);
    };

    showCreateModal = () => {
        this.setState({
            ...this.state,
            upsellModal: {
                ...this.state.upsellModal,
                show: true
            }
        })
    };

    hideCreateModal = (refresh) => {
        this.setState({
            ...this.state,
            upsellModal: {
                ...this.state.upsellModal,
                show: false
            }
        }, () => {
            if (refresh) {
                this.loadUpsellSettingsAndProducts();
            }
        })
    };

    showDeleteModal = (upsellId) => {
        this.setState({
            ...this.state,
            removeProductModal: {
                ...this.state.removeProductModal,
                show: true,
                upsellId: upsellId
            }
        })
    };

    hideDeleteModal = (refresh) => {
        this.setState({
            ...this.state,
            removeProductModal: {
                ...this.state.removeProductModal,
                show: false
            }
        }, () => {
            if (refresh) {
                this.loadUpsellSettingsAndProducts();
            }
        })
    };

    onSortStart = () => {
        this.toggleDraggableCursor(true);
    };

    onSortEnd = (e) => {
        this.toggleDraggableCursor(false);
        this.props.reorderUpsellProducts(this.props.match.params.id, e.oldIndex, e.newIndex, this.loadUpsellSettingsAndProducts);
    };

    toggleDraggableCursor(set) {
        if (set) {
            document.getElementById("upsellProductContainer").classList.add("dragCursor");
        } else {
            document.getElementById("upsellProductContainer").classList.remove("dragCursor");

        }
    }

    saveMessage = () => {
        this.props.setUpsellMessage(this.props.match.params.id, this.state.upsellMessage, () => {
            this.loadUpsellSettingsAndProducts();
        });
    };

    renderMessageInput() {
        const {inputField, inputContainer} = styles;
        return (
            <div style={inputContainer}>
                <input type="text"
                       style={inputField}
                       value={this.state.upsellMessage}
                       onChange={(e) => {
                           this.setState({...this.state, upsellMessage: e.target.value})
                       }}
                />
                <Button onClick={this.saveMessage} color="primary">
                    <MaterialIcon icon="save" color="#fff" size={18}/><span
                    style={{paddingLeft: 4}}>{i18n.t('common:buttons.save')}</span>
                </Button>
            </div>
        );
    }

    renderAddButton() {
        return (
            <div>
                <div style={{display: 'flex', justifyContent: 'flex-end', margin: '0 0 10px 0'}}>
                    <Button disabled={this.props.upsellSettings.upsellProducts.length >= 4} color="primary"
                            onClick={this.showCreateModal}>
                        <MaterialIcon icon="add_circle_outline" color="#fff" size={20}/>
                        &nbsp;{i18n.t('common:buttons.addProduct')}
                    </Button>
                </div>
                <p style={{textAlign: 'right'}}>{i18n.t('screens:upsellScreen.addBtnHint')}</p>
            </div>
        );
    }

    renderUpsellProducts() {
        const isLargeImageDesign = this.props.serviceSettingsGeneral ? this.props.serviceSettingsGeneral.enableLargeImageDesign : null;
        return (
            <Fragment>
                <SortableUpsellList
                    axis='x'
                    lockToContainerEdges={true}
                    upsellProducts={this.props.upsellSettings.upsellProducts}
                    restaurantCurrency={this.props.restaurantCurrency}
                    distance={15}
                    helperClass="draggableUpsellProducts"
                    onSortStart={this.onSortStart}
                    onSortEnd={this.onSortEnd}
                    showDeleteModal={this.showDeleteModal}
                    isLargeImageDesign={isLargeImageDesign}
                />
                {this.props.upsellSettings.upsellProducts.length > 0 ?
                    <p>{i18n.t('screens:upsellScreen.dragDropProducts')}</p>
                    : null}
            </Fragment>
        )
    }

    renderHeading(iconName, label) {
        const {screenHeading} = styles;

        return (
            <div>
                <div style={screenHeading}>
                    <MaterialIcon icon={iconName} color="#0288d1" size={22}/>&nbsp;
                    {label}
                </div>
            </div>
        );
    }

    render() {
        const {productListHeading} = styles;
        return (
            <Fragment>
                {this.state.upsellModal.show ?
                    <CreateUpsellProductModal
                        toggleModal={this.hideCreateModal}
                        modalData={this.state.upsellModal}
                        restaurantId={this.props.match.params.id}
                        upsellProducts={this.props.upsellSettings.upsellProducts}
                    />
                    : null}
                {this.state.removeProductModal.show ?
                    <DeleteUpsellProductModal
                        toggleModal={this.hideDeleteModal}
                        modalData={this.state.removeProductModal}
                        restaurantId={this.props.match.params.id}
                    />
                    : null}
                <div>
                    <Section>
                        {this.renderHeading('message', i18n.t('screens:upsellScreen.message'))}
                        {this.renderMessageInput()}
                    </Section>
                    <Section>

                        <div style={productListHeading}>
                            {this.renderHeading('add_shopping_cart', i18n.t('screens:upsellScreen.products'))}
                            {this.renderAddButton()}
                        </div>
                        {this.renderUpsellProducts()}
                    </Section>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        upsellSettings: state.upsellSettings,
        restaurantCurrency: state.restaurant.currency,
        serviceSettingsGeneral: state.serviceSettingsGeneral,
        restaurant: state.restaurant,
    }
};

export default connect(mapStateToProps, {
    loadUpsellSettingsAndProducts,
    reorderUpsellProducts,
    clearUpsellSettings,
    setUpsellMessage,
    loadRestaurantSettings
})(UpsellScreen);

const styles = {
    productListHeading: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between'
    },
    inputField: {
        marginLeft: 20,
        marginRight: 20,
        padding: '6px 12px',
        width: 400,
        maxWidth: '90%',
        borderRadius: 0,
        height: 46,
        fontSize: 14
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        paddingLeft: 0,
        color: '#0288d1',
        marginBottom: 20,
        marginLeft: 25,
        width: 299
    },
    productContainer: {
        position: 'relative',
        padding: 0,
        margin: 0,
        display: 'flex',
        flexWrap: 'wrap',
        width: 1160,
        height: 440,
    },
    upsellProductItem: {
        display: 'block',
        position: 'relative',
        width: 250,
        height: 400,
        margin: 20,
        boxShadow: '0px 0px 20px #0008',
        cursor: 'grab',
        background: '#fff',
        userSelect: 'none'
    },
    imageContainer: {
        width: '100%',
        height: 200,
        paddingTop: 40,
        userSelect: 'none'
    },
    noImageContainer: {
        width: '100%',
        height: '100%',
        background: '#F0F0F0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 18

    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        userSelect: 'none'
    },
    name: {
        width: '100%',
        height: '40px',
        textAlign: 'center',
        fontSize: 20,
        padding: '5px 10px',
        overflow: 'hidden'
    },
    description: {
        width: '100%',
        height: 70,
        textAlign: 'center',
        fontSize: 14,
        padding: '0 10px',
        overflow: 'hidden'
    },
    price: {
        width: '100%',
        height: 45,
        padding: 10,
        textAlign: 'center',
        fontSize: 16
    },
    priority: {
        borderTop: '1px solid #888',
        width: '100%',
        height: 44,
        padding: 10,
        textAlign: 'center',
        fontSize: 16
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/upsell/UpsellScreen.js